<template v-if="passed_filter && option_filter">
    <div>
        <tile-question-layout v-show="backing_glass_required" :options_loaded="options_loaded" :passed_filter="passed_filter" :title="title" :loading="loading" v-model:target="localTarget" :filtered_option_list="filtered_option_list" :thumb_url="thumbURL" :component_id="component_id" :fabricator="fabricator">

        </tile-question-layout>
    </div>
</template>

<script type="text/ecmascript-6">
    import TileQuestion from "./mixin/TileQuestion.vue";

    export default {
        mixins: [
            TileQuestion
        ],
        props: {
            title: {
                default(){
                    return 'Glass Backing Design';
                }
            },
            panelGlassId: {
                required: true,
            },
            sideVariant: {
                required: false,
                default() {
                    return 1;
                }
            },
        },
        computed: {
            backing_glass_required(){
                return Array.isArray(this.filtered_option_list) && this.filtered_option_list.length > 0;
            },
            thumbURL(){
                return '/thumb/glass/';
            },
            passed_filter(){
                return this.variable_ready(this.panelGlassId, this.sideVariant);
            },
            option_filter(){
                return this.filtered_option_list.length > 0 && valid_selection;
            },
            url(){
                return '/api/options/' + this.fabricator + '/side-glass-backing-design?panel_glass_id=' + this.panelGlassId + '&side_variant=' + this.sideVariant;
            },
            cache_key(){
                return '_' + this.panelGlassId + '_' + this.sideVariant;
            },
        },
        watch: {
            'panelGlassId': function (val, oldVal) {
                this.update_options();
            },
            'sideVariant': function (val, oldVal) {
                this.update_options();
            },
        },
    }
</script>
